import React from "react";
import { FaChevronRight } from "react-icons/fa";
import "./PostCard.css";

const PostCard = ({ date, metrics = {}, onClick }) => {
  return (
<div className="post-card" onClick={onClick}>
  {/* Header: Date */}
  <div className="post-header">{date}</div>

  {/* Metrics Grid */}
  <div className="post-metrics">
    <div className="metric-row">
      <span className="metric-label">Posts:</span>
      <span className="metric-value">{metrics.posts || 0}</span>
    </div>
    <div className="metric-row">
      <span className="metric-label">Views:</span>
      <span className="metric-value">{metrics.views || 0}</span>
    </div>
    <div className="metric-row">
      <span className="metric-label">Clicks:</span>
      <span className="metric-value">{metrics.clicks || 0}</span>
    </div>
    <div className="metric-chevron">
      <FaChevronRight />
    </div>
  </div>
</div>


  );
};

export default PostCard;
